module.exports = __webpack_public_path__ + "static/media/familia-casa.77bfe0d9.jpg";